<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
            v-toolbar-title( style='padding : 10px') {{ title }}
          PenyelesaianUsulan()
</template>

<script>
import PenyelesaianUsulan from "@/components/PenyelesaianUsulan.vue";

export default {
  name: "ClosingUsulan",
  components: {
    PenyelesaianUsulan,
  },
  data () {
    return {
      title: 'Penyelesaian Pekerjaan',
    }
  },
  mounted () {
  },
  computed: {

  },
  methods: {
   
    },  
  watch :{
     
      }
};
</script>
